export default {
      id: "i-noun-culture-usage",
      viewBox: "0 0 40 35",
      url: __webpack_public_path__ + "img/sprite.svg#i-noun-culture",
      toString: function () {
        return this.url;
      }
    }